// extracted by mini-css-extract-plugin
export default {"deleteAlert":"styles_deleteAlert__5RloY","deleteAlertButtons":"styles_deleteAlertButtons__5Rtlv"};